(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLOSE_MS = 280;

  function initDrawerMotion(drawer) {
    if (!drawer || drawer.dataset.premiumMotionInit) return;
    // Only wrap close() once the cart-drawer custom element has been upgraded.
    if (typeof drawer.close !== 'function') return;
    drawer.dataset.premiumMotionInit = 'true';
    drawer.classList.add('is-motion-enhanced');

    var origClose = drawer.close.bind(drawer);
    var origOpen = drawer.open.bind(drawer);
    var closeTimer = null;

    drawer.close = function () {
      if (REDUCED || !drawer.classList.contains('active')) {
        origClose();
        return;
      }
      // Ignore repeat close requests while the exit is already running.
      if (closeTimer) return;
      drawer.classList.add('is-closing');
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        origClose();
        drawer.classList.remove('is-closing', 'is-opening');
        resetEnterStates(drawer);
      }, CLOSE_MS);
    };

    // Reopening mid-exit cancels the pending close so the drawer slides back in.
    drawer.open = function (triggeredBy) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
        drawer.classList.remove('is-closing');
      }
      origOpen(triggeredBy);
    };

    // cart-drawer.js binds the overlay to the original close() in its
    // constructor, before this wrapper exists. Intercept overlay clicks in the
    // capture phase so they always go through the animated close above.
    drawer.addEventListener(
      'click',
      function (evt) {
        if (evt.target.id !== 'CartDrawer-Overlay') return;
        evt.stopPropagation();
        drawer.close();
      },
      true
    );

    // runOpenSequence() itself changes the class attribute, so only react to
    // the closed -> open transition; otherwise the observer re-triggers forever.
    var wasActive = drawer.classList.contains('active');
    var observer = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive && !drawer.classList.contains('is-closing')) {
        runOpenSequence(drawer);
      }
      wasActive = isActive;
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function resetEnterStates(root) {
    root.querySelectorAll('.cart-premium-enter').forEach(function (el) {
      el.classList.remove('cart-premium-enter');
    });
  }

  function runOpenSequence(drawer) {
    if (REDUCED) return;

    drawer.classList.add('is-opening');
    resetEnterStates(drawer);

    var header = drawer.querySelector('.drawer__header');
    var items = drawer.querySelectorAll('.cart-drawer .cart-item');
    var footerBlocks = drawer.querySelectorAll('.drawer__footer > *');

    if (header) header.classList.add('cart-premium-enter');

    items.forEach(function (item, index) {
      item.style.setProperty('--cp-stagger', index * 65 + 'ms');
      item.classList.add('cart-premium-enter');
    });

    footerBlocks.forEach(function (block, index) {
      block.style.setProperty('--cp-stagger', items.length * 65 + index * 55 + 80 + 'ms');
      block.classList.add('cart-premium-enter');
    });
  }

  // Dawn replaces the totals markup on every AJAX update, so the last total is
  // remembered on the persistent root and compared after each cartUpdate.
  function initTotalPulse(root) {
    if (!root) return;
    var totalEl = root.querySelector('.totals__total-value');
    if (!totalEl) return;

    var next = totalEl.textContent.trim();
    var last = root.dataset.premiumLastTotal;
    root.dataset.premiumLastTotal = next;
    if (last === undefined || last === next || REDUCED) return;

    totalEl.classList.remove('is-total-updated');
    void totalEl.offsetWidth;
    totalEl.classList.add('is-total-updated');
  }

  function initQuantityFeedback(root) {
    if (!root || root.dataset.qtyFeedbackInit) return;
    root.dataset.qtyFeedbackInit = 'true';

    root.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.quantity__button');
      if (!btn) return;
      var qty = btn.closest('.quantity');
      if (!qty || REDUCED) return;
      qty.classList.add('is-qty-bump');
      window.setTimeout(function () {
        qty.classList.remove('is-qty-bump');
      }, 180);
    });
  }

  function initPageMotion() {
    var page = document.querySelector('cart-items.cart-premium');
    if (!page || page.dataset.premiumPageMotionInit) return;
    page.dataset.premiumPageMotionInit = 'true';
    page.classList.add('is-motion-enhanced');

    if (REDUCED) return;

    var heading = page.querySelector('.title');
    if (heading) heading.classList.add('cart-premium-enter');

    page.querySelectorAll('.cart-items .cart-item').forEach(function (item, index) {
      item.style.setProperty('--cp-stagger', index * 65 + 'ms');
      item.classList.add('cart-premium-enter');
    });
  }

  function bounceBadge(badge) {
    badge.classList.remove('is-bouncing');
    void badge.offsetWidth;
    badge.classList.add('is-bouncing');
    badge.addEventListener('animationend', function () {
      badge.classList.remove('is-bouncing');
    }, { once: true });
  }

  function pulseCartIcon() {
    if (REDUCED) return;
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    // Ring-flash the icon wrapper immediately
    icon.classList.remove('is-cart-updated');
    void icon.offsetWidth;
    icon.classList.add('is-cart-updated');
    icon.addEventListener('animationend', function () {
      icon.classList.remove('is-cart-updated');
    }, { once: true });

    // Badge: bounce if already in DOM; otherwise watch for Dawn to inject it
    var badge = icon.querySelector('.cart-count-bubble');
    if (badge) {
      bounceBadge(badge);
    } else {
      var obs = new MutationObserver(function () {
        var b = icon.querySelector('.cart-count-bubble');
        if (b) {
          obs.disconnect();
          bounceBadge(b);
        }
      });
      obs.observe(icon, { childList: true, subtree: true });
      // Auto-disconnect after 4s to avoid memory leak if badge never appears
      window.setTimeout(function () { obs.disconnect(); }, 4000);
    }
  }

  function refreshAfterCartUpdate() {
    var drawer = document.querySelector('cart-drawer.cart-premium');
    if (drawer && drawer.classList.contains('active')) {
      runOpenSequence(drawer);
    }
    initTotalPulse(drawer);
    initTotalPulse(document.getElementById('main-cart-footer'));
    initQuantityFeedback(drawer);
    initQuantityFeedback(document.querySelector('cart-items.cart-premium'));
    pulseCartIcon();
  }

  var cartUpdateSubscribed = false;

  function boot() {
    document.documentElement.classList.add('cart-premium-ready');

    var drawer = document.querySelector('cart-drawer.cart-premium');
    if (drawer) {
      // This script is deferred ahead of cart-drawer.js, so wait for the
      // element to be defined (and upgraded) before touching its methods.
      customElements.whenDefined('cart-drawer').then(function () {
        initDrawerMotion(drawer);
      });
      initTotalPulse(drawer);
      initQuantityFeedback(drawer);
    }

    initPageMotion();
    initTotalPulse(document.getElementById('main-cart-footer'));
    initQuantityFeedback(document.querySelector('cart-items.cart-premium'));

    if (!cartUpdateSubscribed && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      cartUpdateSubscribed = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        window.setTimeout(refreshAfterCartUpdate, 60);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
